import { DEFAULT_PLAYER_CONFIG } from "@tv4/avod-web-player-common";

import ForwardSvg from "../icons/ForwardIcon.svg";
import { useControls } from "../providers/CoreProvider";
import { useTranslations } from "../providers/TranslationsProvider";
import { PlayerControlButtonComponent } from "./PlayerControlButton";

const SEEK_AMOUNT = DEFAULT_PLAYER_CONFIG.seekAmount;

export const SeekForwardButton = () => {
  const controls = useControls();
  const translations = useTranslations();

  const seek = () => {
    controls?.seekForward?.(SEEK_AMOUNT);
  };

  return (
    <PlayerControlButtonComponent
      aria-label={translations("player__a11y__label_skip_ahead", {
        seconds: SEEK_AMOUNT,
      })}
      aria-keyshortcuts={"→"}
      onClick={seek}
      Icon={<ForwardSvg />}
      interactive
      hoverText={translations("player__a11y__hover_label_seek_forward_button", {
        seconds: SEEK_AMOUNT,
      })}
    />
  );
};

export default SeekForwardButton;
